import { useCallback, useEffect, useState } from "react";

import { getSubscriptionPlans } from "../../../api";
import { logError } from "../../../logging/loggingService";

export default function usePlanOptions({ open }) {
    const [planOptions, setPlanOptions] = useState([]);
    const [planOptionsLoading, setPlanOptionsLoading] = useState(false);
    const [planOptionsError, setPlanOptionsError] = useState("");

    const loadPlanOptions = useCallback(async () => {
        setPlanOptionsLoading(true);
        setPlanOptionsError("");
        try {
            const res = await getSubscriptionPlans();
            if (res.status >= 200 && res.status < 300) {
                const options = Array.isArray(res.data) ? res.data : [];
                setPlanOptions(options);
            } else {
                throw new Error("Tarife konnten nicht geladen werden.");
            }
        } catch (err) {
            logError("Tarife konnten nicht geladen werden", err, { component: "Account" });
            setPlanOptionsError("Tarife konnten nicht geladen werden. Bitte versuche es erneut.");
        } finally {
            setPlanOptionsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (open && !planOptionsLoading && planOptions.length === 0) {
            loadPlanOptions();
        }
    }, [open, planOptionsLoading, planOptions.length, loadPlanOptions]);

    return {
        planOptions,
        planOptionsLoading,
        planOptionsError,
    };
}
